/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const eventUtil = {
  on(event: any, callback: (data: any) => void) {
    if (typeof document !== 'undefined') {
      document.addEventListener(event, e => callback(e.detail));
    }
  },
  dispatch(event: any, data: any) {
    if (typeof document !== 'undefined') {
      document.dispatchEvent(new CustomEvent(event, { detail: data }));
    }
  },
  remove(event: any, callback: () => void) {
    if (typeof document !== 'undefined') {
      document.removeEventListener(event, callback);
    }
  },
};
